import { routes } from './colaboradores.routes';
import AtvColaboradoresListController from "./directory/directory.controller";
import AtvColaboradoresDetailsController from "./details/details.controller";
export default angular.module('app.ativos.colaboradores', [])
    .config(routes)
    .controller('AtvColaboradoresListController', AtvColaboradoresListController)
    .controller('AtvColaboradoresDetailsController', AtvColaboradoresDetailsController)
    .name;
